// extracted by mini-css-extract-plugin
module.exports = {"table":"TableSection_table_3Sy7Z","pagination":"TableSection_pagination_3q7C6"};